"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseSuspectedDisplayNameEmailAddress(parseString) {
    // Prepare the string
    parseString = parseString.replace(/['"]+/g, '');
    parseString = parseString.trim();
    // Split on various potential opening brackets
    var splits = parseString.split(/([<\[\({])+/g);
    var displayName;
    var emailAddress = parseString;
    if (splits.length == 3) {
        displayName = splits[0].trim();
        emailAddress = splits[2].split(/([>\]\)}])+/g)[0].trim();
    }
    return {
        EmailAddress: {
            MailboxType: 'OneOff',
            RoutingType: 'SMTP',
            EmailAddress: emailAddress,
            Name: displayName ? displayName : emailAddress,
        },
    };
}
exports.default = parseSuspectedDisplayNameEmailAddress;
//# sourceMappingURL=parseSuspectedDisplayNameEmailAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/parseSuspectedDisplayNameEmailAddress.js
// module id = 2754
// module chunks = 2 3 4 45